app.controller('CommonScrollBreakController', ['$rootScope', '$scope', '$document', function ($rootScope, $scope, $document) {

    const breakAt = document.getElementById("furtherDown");
    $scope.is_scroll_break_met = false;


    if (typeof (breakAt) != 'undefined' && breakAt != null) {
        $document.on('scroll', function () {
            const isScrollBreakMet = window.scrollY > breakAt.offsetTop;
            if (isScrollBreakMet !== $scope.is_scroll_break_met) {
                $scope.is_scroll_break_met = isScrollBreakMet;
                $rootScope.$apply();
            }
        })
    }

}]);